<app-title-section></app-title-section>
<div class="  card flex-grow mb-0" style="margin-left: 15px; margin-right: 15px; background-color: transparent">
    <div class="content-area-wrapper" style="height: 87vh ;  gap: 16px">
        <!-- Sidebar Left -->
        <div class="card" style="width: 400px">
            <app-layout-step-fourniss
                    [steps]="steps"
                    [currentStep]="currentStep"
                    (goBack)="retour()"
                    (stepSelected)="onTimelineStepSelected($event)">
            </app-layout-step-fourniss>
        </div>

        <!-- Content Right -->
        <div class="card content-right custom-scroll " style="overflow: auto;">

            <div class="content-wrapper p-0 content-right-r ">

                <div class="card-body ">
                    <div class="wizard-content">
                        <!-- Step 0: Détails de l’entreprise -->
                        <div *ngIf="currentStep === 0" class="step-form">
                            <form #step1Form="ngForm" (ngSubmit)="handleStepCompletion(0)">
                                <div class="form-section rounded border-style p-0">
                                    <div style="margin: 33px 34px 36px 36px">
                                        <p class="titre1" style="padding: 12px">Détails de l’entreprise</p>

                                        <!-- Nom et Identifiant -->
                                        <div class="col-12">
                                            <div class="row g-3">
                                                <!-- Nom de l'entreprise -->
                                                <div class="col-md-6 position-relative">
                                                    <label class="form-label" for="nomEntreprise">Nom de l'entreprise <span class="req" aria-required="true">*</span></label>
                                                    <div class="input-group">
                                                        <input
                                                                type="text"
                                                                class="form-control"
                                                                id="nomEntreprise"
                                                                placeholder="Entrez le nom de l’entreprise"
                                                                [(ngModel)]="fournisseur.nom_entreprise"

                                                                name="nomEntreprise"
                                                                required
                                                                #nomEntrepriseControl="ngModel"
                                                                (ngModelChange)="validateStep1()"
                                                                aria-required="true"
                                                                [ngClass]="{'is-invalid': (nomEntrepriseControl.invalid && (nomEntrepriseControl.dirty || nomEntrepriseControl.touched || submittedStep1)) }"
                                                        />
                                                    </div>
                                                    <div class="error-container" style="min-height: 20.75px;">
                                                        <small *ngIf="nomEntrepriseControl.invalid && (nomEntrepriseControl.dirty || nomEntrepriseControl.touched || submittedStep1)" class="text-danger">
                                                            Le nom de l'entreprise est obligatoire.
                                                        </small>
                                                    </div>
                                                </div>

                                                <!-- Numéro d'identification fiscale -->
                                                <div class="col-md-6 position-relative">
                                                    <label class="form-label" for="numeroIdentificationFiscale">Numéro d'identification fiscale <span class="req" aria-required="true">*</span></label>
                                                    <div class="input-group">
                                                        <input
                                                                type="text"
                                                                class="form-control"
                                                                id="numeroIdentificationFiscale"
                                                                placeholder="Entrez l’identifiant"
                                                                [(ngModel)]="fournisseur.numero_identification_fiscale"
                                                                name="numeroIdentificationFiscale"
                                                                required
                                                                #numeroIdentificationFiscaleControl="ngModel"
                                                                (ngModelChange)="validateStep1()"
                                                                aria-required="true"
                                                                [ngClass]="{'is-invalid': (numeroIdentificationFiscaleControl.invalid && (numeroIdentificationFiscaleControl.dirty || numeroIdentificationFiscaleControl.touched || submittedStep1)) }"
                                                        />
                                                    </div>
                                                    <div class="error-container" style="min-height: 20.75px;">
                                                        <small *ngIf="numeroIdentificationFiscaleControl.invalid && (numeroIdentificationFiscaleControl.dirty || numeroIdentificationFiscaleControl.touched || submittedStep1)" class="text-danger">
                                                            Le numéro d'identification fiscale est obligatoire.
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Site web (inchangé) -->
                                        <div class="col-12">
                                            <label class="form-label" for="siteWeb" style="margin-top: 4px;">Site web</label>
                                            <input
                                                    type="url"
                                                    class="form-control"
                                                    id="siteWeb"
                                                    placeholder="Entrez l’URL du site web"
                                                    [(ngModel)]="fournisseur.site_web"
                                                    name="siteWeb"
                                                    (ngModelChange)="validateStep1()"
                                            />
                                        </div>

                                        <p class="titre1" style="padding: 34px 12px 12px 12px;">Personne à contacter</p>

                                        <!-- Civilité -->
                                        <div class="col-12">
                                            <label class="form-label">Civilité <span class="req" aria-required="true">*</span></label>
                                            <div class="d-flex align-items-center gap-4"
                                                 [ngClass]="{'is-invalid': civiliteControl.invalid && (civiliteControl.dirty || civiliteControl.touched || submittedStep1)}">
                                                <div class="form-check ms-3 me-1 p-0">
                                                    <label class="container">
                                                        <input
                                                                class="tva-radio"
                                                                type="radio"
                                                                required #civiliteControl="ngModel"
                                                                name="civilite" value="Homme" id="civilite_homme"
                                                                [(ngModel)]="fournisseur.civilite"
                                                                (change)="validateStep1()"
                                                        />
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <label class="form-check-label ms-3" for="civilite_homme" style="margin-left: 6px; margin-right: 16px;">Homme</label>
                                                </div>
                                                <div class="form-check ms-3 me-1 p-0">
                                                    <label class="container">
                                                        <input
                                                                class="tva-radio"
                                                                type="radio"
                                                                required #civiliteControl="ngModel"
                                                                name="civilite" value="Femme" id="civilite_femme"
                                                                [(ngModel)]="fournisseur.civilite"
                                                                (change)="validateStep1()"
                                                        />
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <label class="form-check-label" for="civilite_femme" style="margin-left: 6px;">Femme</label>
                                                </div>
                                            </div>
                                            <div class="text-danger small" *ngIf="civiliteControl.invalid && (civiliteControl.dirty || civiliteControl.touched || submittedStep1)">
                                                La civilité est obligatoire.
                                            </div>
                                        </div>

                                        <!-- Nom et Email -->
                                        <div class="col-12">
                                            <div class="row g-3">
                                                <!-- Nom du contact -->
                                                <div class="col-md-6 position-relative">
                                                    <label class="form-label" for="contactName" style="margin-top: 24px;">Nom du contact <span class="req" aria-required="true">*</span></label>
                                                    <div class="input-group">
                                                        <input
                                                                type="text"
                                                                class="form-control"
                                                                id="contactName"
                                                                placeholder="Entrez le nom du contact"
                                                                [(ngModel)]="fournisseur.identifiant_unique"
                                                                name="contactName"
                                                                required
                                                                #contactNameControl="ngModel"
                                                                (ngModelChange)="validateStep1()"
                                                                aria-required="true"
                                                                [ngClass]="{'is-invalid': contactNameControl.invalid && (contactNameControl.dirty || contactNameControl.touched || submittedStep1)}"
                                                        />
                                                    </div>
                                                    <div class="error-container" style="min-height: 20.75px;">
                                                        <small *ngIf="contactNameControl.invalid && (contactNameControl.dirty || contactNameControl.touched || submittedStep1)" class="text-danger">
                                                            Le nom du contact est obligatoire.
                                                        </small>
                                                    </div>
                                                </div>

                                                <!-- Email -->
                                                <div class="col-md-6 position-relative">
                                                    <label class="form-label" for="email" style="margin-top: 24px;">Email</label>
                                                    <div class="input-group">
                                                        <input
                                                                type="email"
                                                                class="form-control"
                                                                id="email"
                                                                placeholder="Entrez l’email"
                                                                [(ngModel)]="fournisseur.emails[0].email"
                                                                name="email"
                                                                email
                                                                #emailControl="ngModel"
                                                                (ngModelChange)="validateStep1()"
                                                                [ngClass]="{'is-invalid': emailControl.invalid && (emailControl.dirty || emailControl.touched)}"
                                                        />
                                                    </div>
                                                    <div class="error-container" style="min-height: 20px; margin-top: 4px;">
                                                        <div *ngIf="emailControl.invalid && (emailControl.dirty || emailControl.touched)" class="text-danger">
                                                            <small *ngIf="emailControl.errors?.['email']">Format d'email invalide (ex. : nom@exemple.com).</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Boutons (inchangés) -->
                                <div class="d-flex justify-content-between mt-4">
                                    <button type="button" class="btn btn-back" (click)="goBack()" style="background-color: rgba(19, 74, 211, 0.16) !important; color: rgba(19, 74, 211, 1);height: 40px">
                                        <i class="bi bi-arrow-left me-2"></i> Retour
                                    </button>
                                    <div class="d-flex gap-2">
                                        <button type="button" class="btn btn-outline-primary" (click)="quickAdd()" [disabled]="isSubmitting" style="height: 40px">
                                            {{ mode === 'edit' ? 'Mettre à jour rapidement' : 'Ajout Rapide' }}
                                        </button>
                                        <button type="button" (click)="handleStepCompletion(0)" class="btn btn-primary" [disabled]="isSubmitting" style="margin-left: 24px;height: 40px">
                                            {{ mode === 'edit' ? 'Modifier' : 'Continuer' }}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <!-- Step 1: Coordonnées (index 1) -->
                        <div *ngIf="currentStep === 1" class="step-form">
                            <form #step2Form="ngForm" (ngSubmit)="handleStepCompletion(1)">
                                <div class="form-section rounded p-3 border-style">
                                    <div class="row p-0 m-0">
                                        <div class="col-md-10 p-0">
                                            <p class="titre1">Téléphones</p>
                                        </div>

                                        <div class="col-12 p-0" style="margin-top: 24px"
                                             *ngFor="let phone of fournisseur.telephones; let index = index; trackBy: trackByIndex">
                                            <div class="row align-items-start">

                                                <!-- Type téléphone -->
                                                <div class="col-md-4 p-0" style="margin-left: 14px">
                                                    <label class="form-label" [for]="'phoneType' + index">Type téléphone</label>
                                                    <select class="form-control phone-input phone-type"
                                                            [(ngModel)]="fournisseur.telephones[index].type"
                                                            [name]="'phoneType' + index"
                                                            [id]="'phoneType' + index"
                                                            [ngClass]="{'has-error': step2Errors.phones[index]?.type}"
                                                            (ngModelChange)="validatePhoneVisual()">
                                                        <option value="">Sélectionner</option>
                                                        <option value="mobile">Mobile</option>
                                                        <option value="fax">Fax</option>
                                                        <option value="whatsapp">WhatsApp</option>
                                                        <option value="viber">Viber</option>
                                                        <option value="support">Support</option>
                                                        <option value="fixe">Fixe</option>
                                                    </select>
                                                    <div class="text-danger small" *ngIf="step2Errors.phones[index]?.type">
                                                        {{ step2Errors.phones[index].type }}
                                                    </div>
                                                </div>

                                                <!-- Code pays -->
                                                <div class="col-md-2">
                                                    <label class="form-label" [for]="'phoneCode' + index">Code pays</label>
                                                    <input type="text"
                                                           class="form-control phone-input"
                                                           [(ngModel)]="fournisseur.telephones[index].code_pays"
                                                           [name]="'phoneCode' + index"
                                                           [id]="'phoneCode' + index"
                                                           placeholder="+216"
                                                           [ngClass]="{'has-error': step2Errors.phones[index]?.code_pays}"
                                                           (ngModelChange)="validatePhoneVisual()" />
                                                    <div class="text-danger small" *ngIf="step2Errors.phones[index]?.code_pays">
                                                        {{ step2Errors.phones[index].code_pays }}
                                                    </div>
                                                </div>

                                                <!-- Numéro de téléphone -->
                                                <div class="col-md-5 p-0">
                                                    <label class="form-label" [for]="'phoneNumber' + index">Numéro de téléphone</label>
                                                    <input type="text"
                                                           class="form-control phone-input phone-number"
                                                           [(ngModel)]="fournisseur.telephones[index].num_tel"
                                                           [name]="'phoneNumber' + index"
                                                           [id]="'phoneNumber' + index"
                                                           placeholder="Ex: 22123456"
                                                           [ngClass]="{'has-error': step2Errors.phones[index]?.number}"
                                                           pattern="^[1-9][0-9]{7}$"
                                                           #phoneControl="ngModel"
                                                           (ngModelChange)="validatePhoneVisual()" />

                                                    <div class="text-danger small" *ngIf="step2Errors.phones[index]?.number">
                                                        {{ step2Errors.phones[index].number }}
                                                    </div>
                                                </div>

                                                <!-- Bouton supprimer/vide -->
                                                <div class="d-flex align-items-center " style="margin-top: 32px;margin-top: 24px">
                                                    <button type="button"
                                                            class="del-button p-0"
                                                            style="height: 43px; width: 43px;margin-bottom: 18px"
                                                            (click)="removeOrClearPhone(index)"
                                                            *ngIf="hasPhoneData(index) || fournisseur.telephones.length > 1"
                                                            [title]="fournisseur.telephones.length > 1 ? 'Supprimer' : 'Vider'">
                                                        −
                                                    </button>
                                                </div>
                                            </div>

                                            <!-- Ajouter un autre téléphone -->
                                            <div class="col-lg-12 p-0" style="margin-top: 24px" *ngIf="index === fournisseur.telephones.length - 1 && fournisseur.telephones.length < 5">
                                                <b style="color: rgba(19, 74, 211, 1); cursor: pointer;"
                                                   (click)="addPhone()">
                                                    Ajouter un numéro de téléphone
                                                </b>
                                            </div>
                                        </div>

                                        <!-- Si aucun téléphone -->
                                        <div  class="col-md-12 p-0" *ngIf="fournisseur.telephones.length === 0" style="margin-top: 15px;">
                                            <b style="color: rgba(19, 74, 211, 1); cursor: pointer;" (click)="addPhone()">
                                                Ajouter un numéro de téléphone
                                            </b>
                                        </div>
                                    </div>

                                    <!-- Address Section -->
                                    <div class="">
                                        <div class="col-md-10 p-0">
                                            <p class="titre1" style="margin-top: 34px">Adresses</p>
                                        </div>

                                        <div *ngFor="let addr of addressArray; let index = index">
                                            <!-- Cartes Facturation / Livraison (inchangées) -->
                                            <div class="row align-items-center mb-0" >

                                                <div class="option-card2 bordered p-0" style="min-height: 80px;"
                                                     [ngClass]="{
                                                               'selected': addr.type === 'facturation',
                                                               'has-error': hasAnyAddressFieldFilled(index) && !addr.type
                                                             }"

                                                     (click)="selectAddressType(index, 'facturation')">
                                                    <div class="radio-icon-container"  style="margin: 20px 40px 0 50px;">


                                                        <label class="container p-0" >
                                                            <input
                                                                    class="tva-radio form-check-input radiobutton"
                                                                    type="radio"
                                                                    value="facturation"
                                                                    [name]="'addressType_' + index"
                                                                    [id]="'facturation_' + index"
                                                                    [(ngModel)]="addr.type"
                                                            />
                                                            <span class="checkmark" style="margin-bottom: 6px;justify-self: start"></span>
                                                        </label>


                                                        <span class="m-icon">
                                                                 <span data-feather="map-pin" [size]="20" ></span>
                                                            </span>

                                                        <span style="font-size: 15px; font-weight: 600; color: rgba(47, 43, 61, 0.9); margin: 0 14px 0 10px">
                            Adresse de facturation
                        </span>
                                                    </div>
                                                    <p style="font-size: 13px; font-weight: 400; text-align: left;margin: 6px 14px 0 40px">
                                                        Adresse où les factures seront envoyées
                                                    </p>
                                                </div>

                                                <div class="option-card2 bordered p-0" style="min-height: 80px;"
                                                     [ngClass]="{
                                                           'selected': addr.type === 'livraison',
                                                           'has-error': hasAnyAddressFieldFilled(index) && !addr.type
                                                         }"
                                                     (click)="selectAddressType(index, 'livraison')">
                                                    <div class="radio-icon-container"  style="margin: 20px 40px 0 50px;">

                                                        <label class="container p-0" >
                                                            <input
                                                                    class="tva-radio form-check-input radiobutton"
                                                                    type="radio"
                                                                    value="livraison" [(ngModel)]="addr.type"
                                                                    [name]="'addressType_' + index"
                                                                    [id]="'livraison_' + index"

                                                            />
                                                            <span class="checkmark" style="margin-bottom: 6px;justify-self: start"></span>
                                                        </label>
                                                        <span class="m-icon">
                                                                   <span data-feather="truck" [size]="20" ></span>
                                                            </span>

                                                        <span style="font-size: 15px; font-weight: 600; color: rgba(47, 43, 61, 0.9); margin: 0 14px 0 10px">
                            Adresse de livraison
                        </span>
                                                    </div>
                                                    <p style="font-size: 13px; font-weight: 400;text-align: left; margin: 6px 14px 0 40px">
                                                        Adresse où les commandes seront livrées
                                                    </p>
                                                </div>

                                                <div class="d-flex align-items-center justify-content-center" style="align-items: flex-end; padding-top: 20px; margin-left: 20px">
                                                    <button
                                                            type="button"
                                                            class="del-button ms-2 p-0"
                                                            style="height: 43px ; width: 43px"
                                                            (click)="removeOrClearAddress(index)"
                                                            *ngIf="hasAddressData(index) || addressArray.length > 1"
                                                            title="{{ addressArray.length > 1 ? 'Supprimer cette adresse' : 'Vider cette adresse' }}"
                                                            style="width: 36px; height: 36px; display: flex; align-items: center; justify-content: center;">
                                                        −
                                                    </button>
                                                </div>

                                            </div>
                                            <div class="text-danger small p-0 m-0" *ngIf="step2Errors.addresses[index]?.type">
                                                {{ step2Errors.addresses[index].type }}
                                            </div>
                                            <!-- CHAMPS ADRESSE - avec bordure rouge + ! -->
                                            <div class="row g-4 d-flex"
                                                 style="width: 100%; margin-left: 2px; margin-top: 10px;">

                                                <!-- Pays -->
                                                <div class="col-md-4 p-0 position-relative">
                                                    <label class="form-label" [for]="'pays' + index">Pays</label>
                                                    <select class="form-control phone-input"
                                                            [(ngModel)]="addr.pays" [name]="'pays' + index"
                                                            [id]="'pays' + index"
                                                            [ngClass]="{'has-error': step2Errors.addresses[index]?.pays}"

                                                            (ngModelChange)="validateAddressVisual()">
                                                        <option value="">Sélectionner un pays</option>
                                                        <option value="France">France</option>
                                                        <option value="Belgique">Belgique</option>
                                                        <option value="Suisse">Suisse</option>
                                                        <option value="Maroc">Maroc</option>
                                                    </select>


                                                    <div class="text-danger small" *ngIf="step2Errors.addresses[index]?.pays">
                                                        {{ step2Errors.addresses[index].pays }}
                                                    </div>
                                                </div>

                                                <!-- Région -->
                                                <div class="col-md-4 position-relative">
                                                    <label class="form-label" [for]="'region' + index">Région</label>
                                                    <select class="form-control phone-input"
                                                            [(ngModel)]="addr.region" [name]="'region' + index"
                                                            [id]="'region' + index"
                                                            [ngClass]="{'has-error': step2Errors.addresses[index]?.region}"
                                                            (ngModelChange)="validateAddressVisual()">
                                                        <option value="">Sélectionner une région</option>
                                                        <option value="Île-de-France">Île-de-France</option>
                                                        <option value="Provence-Alpes-Côte d'Azur">Provence-Alpes-Côte
                                                            d'Azur
                                                        </option>

                                                    </select>
                                                    <div class="text-danger small" *ngIf="step2Errors.addresses[index]?.region">
                                                        {{ step2Errors.addresses[index].region }}
                                                    </div>

                                                </div>

                                                <!-- Code postal -->
                                                <div class="col-md-4 position-relative pr-0">
                                                    <label class="form-label" [for]="'codePostal' + index">Code
                                                        postal</label>
                                                    <input
                                                            type="text"
                                                            class="form-control phone-input"
                                                            [(ngModel)]="addr.code_postal"
                                                            [name]="'codePostal' + index"
                                                            placeholder="Entrez le code postal"
                                                            [ngClass]="{'has-error': step2Errors.addresses[index]?.code_postal}"
                                                            (ngModelChange)="validateAddressVisual()"
                                                    />


                                                    <div class="text-danger small" *ngIf="step2Errors.addresses[index]?.code_postal">
                                                        {{ step2Errors.addresses[index].code_postal }}
                                                    </div>
                                                </div>


                                            </div>
                                            <!-- Adresse complète -->
                                            <div class="col-12 position-relative p-0" style="margin-top: 24px">
                                                <label class="form-label" [for]="'adresse' + index">Adresse</label>
                                                <input
                                                        type="text"
                                                        class="form-control"
                                                        [(ngModel)]="addr.adresse"
                                                        [name]="'adresse' + index"
                                                        placeholder="Entrez Adresse"
                                                        [ngClass]="{'has-error': step2Errors.addresses[index]?.adresse}"
                                                        (ngModelChange)="validateAddressVisual()"
                                                />


                                                <div class="text-danger small" *ngIf="step2Errors.addresses[index]?.adresse">
                                                    {{ step2Errors.addresses[index].adresse }}
                                                </div>
                                            </div>
                                            <!-- Ajouter une autre adresse -->
                                            <div class="col-lg-12 p-0" style="margin-top: 24px"
                                                 *ngIf="index === addressArray.length - 1 && addressArray.length < 5">
                                                <a style="color: rgba(19, 74, 211, 1); cursor: pointer;"
                                                   (click)="addAddress()">
                                                    <b>Ajouter une adresse</b>
                                                </a>
                                            </div>
                                        </div>

                                        <!-- Si aucune adresse -->
                                        <div class="col-md-12 p-0" *ngIf="addressArray.length === 0"
                                             style="margin-top: 15px;">
                                            <a style="color: rgba(19, 74, 211, 1); cursor: pointer;"
                                               (click)="addAddress()">
                                                <b>Ajouter une adresse</b>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-between align-items-center mt-4">
                                    <button
                                            type="button"
                                            class="btn btn-back"
                                            (click)="goBack()"
                                            style="background-color: rgba(19, 74, 211, 0.16) !important; color: rgba(19, 74, 211, 1);height: 40px"
                                    >
                                        <i class="bi bi-arrow-left me-2"></i> Retour
                                    </button>
                                    <div class="d-flex gap-2">
                                        <button
                                                type="button"
                                                class="btn btn-outline-primary"
                                                (click)="quickAdd()"
                                                [disabled]="!isStep1Valid || !isStep2Valid || isSubmitting"
                                                style="height: 40px"
                                        >
                                            {{ mode === 'edit' ? 'Mettre à jour rapidement' : 'Ajout Rapide' }}
                                        </button>
                                        <button
                                                type="button"
                                                class="btn btn-primary"
                                                (click)="handleStepCompletion(1)"
                                                [disabled]="!isStep2Valid || isSubmitting"
                                                style="margin-left: 24px; height: 40px"
                                        >
                                            Continuer
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <!-- Étape : Paramètres des données (GET param-tables / table Fournisseur) -->
                        <div *ngIf="currentStep === 2" class="step-form tier-param-data-step">
                            <div class="p-2 border-style">
                                <h6 class="mb-3 size15" style="color: #2F2B3DE5"><b>Paramètres des données</b></h6>
                                <p class="size13 mb-3" style="color: #6E6B7B">
                                    Champs personnalisés pour les fournisseurs.
                                </p>
                                <div *ngIf="paramTablesLoading" class="text-muted mb-2">Chargement…</div>
                                <div
                                    *ngFor="let row of paramTableRows; let i = index"
                                    class="mb-3">
                                    <label class="form-label size13 mb-1 d-block">{{ row.libelle }}</label>
                                    <ng2-flatpickr
                                        *ngIf="row.type === 'date'"
                                        class="w-100"
                                        [name]="'paramValeurDateFr' + i"
                                        [config]="paramDateFlatpickrOptions"
                                        [(ngModel)]="row.valeur"
                                        (ngModelChange)="onParamDateValeurChange(row, $event)"
                                        placeholder="jj/mm/aaaa"
                                    ></ng2-flatpickr>
                                    <ng-select
                                        *ngIf="row.type === 'select'"
                                        class="ng-select-custom w-100"
                                        [inputId]="'paramValeurSelectFr' + i"
                                        [items]="getParamSelectOptions(row.param_table_id)"
                                        bindLabel="label"
                                        bindValue="value"
                                        [(ngModel)]="row.valeur"
                                        [name]="'paramValeurSelectFr' + i"
                                        [clearable]="true"
                                        placeholder="Choisir une option"
                                        [notFoundText]="'Aucune option'"
                                    ></ng-select>
                                    <input
                                        *ngIf="row.type !== 'date' && row.type !== 'select'"
                                        type="text"
                                        class="form-control"
                                        [(ngModel)]="row.valeur"
                                        [name]="'paramValeurFr' + i"
                                        placeholder="Valeur"
                                        autocomplete="off">
                                </div>
                            </div>
                            <div class="d-flex justify-content-between mt-2">
                                <button type="button" (click)="goBack()" class="btn btn-back"
                                        style="background-color: rgba(19, 74, 211, 0.16) !important; color: rgba(19, 74, 211, 1);height: 40px">
                                    <i class="bi bi-arrow-left me-2"></i> Retour
                                </button>
                                <button
                                        type="button"
                                        class="btn btn-primary"
                                        (click)="handleStepCompletion(2)"
                                        [disabled]="isSubmitting"
                                        style="height: 40px">
                                    {{ mode === 'edit' ? 'Mettre à jour' : 'Valider' }}
                                </button>
                            </div>
                        </div>

                        <!-- Step 3: Terminé -->
                        <div *ngIf="currentStep === 3" class="step-form">
                            <div class="text-center form-section rounded p-4 border-style">
                                <div class="success-icon mb-2">
                                    <img src="./../../../../assets/images/logo/check.jpg" alt="check" style="width: 80px; height: auto;">
                                </div>
                                <h3 class="mb-3" style="font-size: 18px;font-weight: 700;color: rgba(47, 43, 61, 0.9)">{{ mode === 'edit' ? 'Fournisseur mis à jour avec succès' : 'Fournisseur ajouté avec succès' }}</h3>
                                <div class="d-flex justify-content-center gap-2">
                                    <button (click)="addNewFournisseur()" class="btn btn-outline-primary" style="margin-right: 6px;">Ajouter Un Nouveau Fournisseur</button>
                                    <button (click)="viewFournisseur()" class="btn btn-primary">Voir Fournisseur</button>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>


            </div>
        </div>
    </div>
</div>
